import { Data, PropertySet } from "datasheets/model/core/Workbook";
import { useAtomValue } from "jotai";
import { Stack, TextField } from "@mui/material";
import { useCallback } from "react";
import { EditableTextField } from "datasheets/components/EditableTextField";
import { selectedObjectAtom } from "./selectedObjectAtom";

export function ObjectEditor({
  sourceData,
  sourceProperties,
  setData,
}: {
  sourceData: Data;
  sourceProperties: PropertySet;
  setData: (callback: (data: Data) => Data) => void;
}) {
  const uncheckedSelectedObjectId = useAtomValue(selectedObjectAtom);
  // Check whether selected object id is still valid
  const selectedObjectId =
    !!uncheckedSelectedObjectId && uncheckedSelectedObjectId in sourceData
      ? uncheckedSelectedObjectId
      : null;
  const setValue = useCallback(
    (propertyId: string, value: any) => {
      if (selectedObjectId) {
        setData((data: Data) => {
          return {
            ...data,
            ...{
              [selectedObjectId]: {
                ...data[selectedObjectId],
                ...{ [propertyId]: value },
              },
            },
          };
        });
      }
    },
    [selectedObjectId, setData]
  );
  const propertyDisplay = !selectedObjectId
    ? null
    : Object.entries(sourceProperties.descriptors).map(([id, descriptor]) => {
        const name = sourceProperties.keyToName[id];
        const value = sourceData[selectedObjectId][id];
        return (
          <EditableTextField
            key={name + value}
            displayText={value}
            setDisplayText={(newValue) => setValue(id, newValue)}
            multiline={true}
          >
            <TextField
              multiline={true}
              label={name}
              value={value}
              InputLabelProps={{ shrink: true }}
            />
          </EditableTextField>
        );
      });
  return (
    <Stack direction="column" height="1vh">
      {propertyDisplay}
    </Stack>
  );
}
